import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, Plus } from "lucide-react";
import { MENU } from "../../lib/content";
import { Kicker, Reveal, scrollToId } from "./Reveal";

export const MenuShowcase = ({ selected = [], onToggle }) => {
  const [active, setActive] = useState(MENU[0].key);
  const cat = MENU.find((m) => m.key === active) ?? MENU[0];

  return (
    <section id="nabidka" data-testid="menu-section" className="py-24 md:py-36 bg-[var(--surface)] border-y border-[var(--line)]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Kicker>Nabídka</Kicker>
          <h2 className="mt-6 font-display text-4xl md:text-6xl font-semibold uppercase leading-[0.95]">Naše <span className="text-[var(--cyan)]">nabídka</span></h2>
          <p className="mt-5 max-w-xl text-[var(--muted)] text-base md:text-lg">Vyberte jídla, která si přejete. Po výběru vám vypracujeme cenovou nabídku.</p>
        </Reveal>
        <div className="mt-10 flex gap-2 overflow-x-auto pb-2 -mx-5 px-5 md:mx-0 md:px-0">
          {MENU.map((m) => (
            <button key={m.key} data-testid={`menu-tab-${m.key}`} onClick={() => setActive(m.key)}
              className={`relative shrink-0 rounded-full px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] border transition-colors ${active === m.key ? "text-white border-[var(--cyan)]" : "text-[var(--muted)] border-[var(--line)] hover:text-[var(--ink)]"}`}>
              {active === m.key && <motion.span layoutId="menu-pill" className="absolute inset-0 rounded-full bg-[var(--cyan)]" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
              <span className="relative">{m.label}</span>
            </button>
          ))}
        </div>
        <div className="mt-12 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6 relative aspect-[4/3] clip-cut overflow-hidden">
            <AnimatePresence initial={false}>
              <motion.img key={cat.key} src={cat.img} alt={cat.label}
                initial={{ opacity: 0, scale: 1.12 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 w-full h-full object-cover" />
            </AnimatePresence>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_35%,rgba(20,24,31,.25))]" />
            <span className="absolute left-5 bottom-5 font-mono text-xs uppercase tracking-[0.2em] bg-white/90 px-3 py-2 border border-[var(--line)]">{cat.label}</span>
          </div>
          <div className="lg:col-span-6">
            <ul data-testid="menu-items" className="divide-y divide-[var(--line)] border-y border-[var(--line)]">
              {cat.items.map((it, i) => {
                const on = selected.includes(it);
                return (
                  <motion.li key={cat.key + it} initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05, duration: 0.6 }}>
                    <button type="button" data-testid={`dish-${cat.key}-${i}`} onClick={() => onToggle?.(it)} aria-pressed={on}
                      className="group w-full py-4 flex items-center gap-5 text-left">
                      <span className="font-mono text-xs text-[var(--cyan)]">{String(i + 1).padStart(2, "0")}</span>
                      <span className="flex-1 text-lg md:text-xl transition-transform duration-500 group-hover:translate-x-2">{it}</span>
                      <span className={`w-8 h-8 shrink-0 rounded-full grid place-items-center border transition-colors ${on ? "bg-[var(--cyan)] border-[var(--cyan)] text-white" : "border-[var(--line)] text-[var(--cyan)] group-hover:border-[var(--cyan)]"}`}>
                        {on ? <Check size={16} /> : <Plus size={16} />}
                      </span>
                    </button>
                  </motion.li>
                );
              })}
            </ul>
            <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--amber)]">Klepnutím přidáte do poptávky · cena na vyžádání</p>
              <button data-testid="menu-cta" onClick={() => scrollToId("poptavka")} className="rounded-full bg-[var(--cyan)] text-white px-6 py-3 text-sm font-semibold hover:bg-[var(--ink)] transition-colors">
                Pokračovat k poptávce{selected.length ? ` (${selected.length})` : ""} →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
